import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { SaveBtn } from "../components/saveBtn";
import { CancelBtn } from "../components/cancelBtn";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function AddClient() {

  const API_URL = process.env.REACT_APP_API_URL;

  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({ mode: "onChange" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cancelClicked, setCancelClicked] = useState(false);
  const [gender, setGender] = useState("Female");
  const [membership, setMembership] = useState("None");
  const [startDate, setStartDate] = useState('');
  const navigate = useNavigate();

  const getDateValue = (data) => {
    setStartDate(data);
  }
  
  const onCancel = () => {
    setCancelClicked(true);
    navigate('/dashboard');
  }

  const onSubmit = async (data) => {
    setIsLoading(true);
    setError(null);
    const newClient = {
      ...data,
      gender: gender,
      balance: data.prepaid,
      membership: membership,
      startdate: startDate,
    }
    
    try{
      const response = await axios.post(`${API_URL}/clients`, newClient);
      if(response.data != null && !cancelClicked){
        alert("Created new client");
        navigate('/dashboard');
        window.location.reload();
      }
    } catch{
      setError("Something went wrong while creating new client. Please try again later")
      alert(error);
    } finally{
      setIsLoading(true);
    }
  };
  return (
    <div className="h-dvh flex items-center flex-col bg-[#545454]">
      <title>Add Client | HairBank</title>
      <div className="flex w-4/5 items-end text-center">
        <div className="w-full">
          <h1 className="text-[#eed495] text-6xl mt-16 xl:mt-5 w-full">
            Add Client
          </h1>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex border-2 mt-20 flex-col h-auto justify-center">
          <div className="flex items-center justify-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="name">Name:</label>
            </div>
            <div>
              <input
                {...register("name", {
                  required: "Name is required",
                })}
                name="name"
                required
                type="text"
                placeholder="Name"
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-36 text-white text-2xl m-3">
              <label htmlFor="gender">Gender:</label>
            </div>
            <div>
              <select id="genders" onChange={(e)=>setGender(e.target.value)} className="text-2xl w-32 ml-5">
                <option value="Female">Female</option>
                <option value="Male">Male</option>
              </select>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="Email">Email:</label>
            </div>
            <div>
              <input
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Invalid email address",
                  }
                })}
                name="email"
                type="text"
                placeholder="Email"
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          {errors.email?.message && (<div className="text-2xl text-red-400 text-center"><span>{errors.email?.message}</span></div>) }
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="contact">Contact:</label>
            </div>
            <div>
              <input
                {...register("contact", {
                  required: "Contact is required",
                })}
                name="contact"
                type="text"
                placeholder="Phone Number"
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="membership">Membership:</label>
            </div>
            <div>
              <select id="memberships" onChange={(e)=>setMembership(e.target.value)} className="text-2xl w-32 ml-3">
                <option value="None">None</option>
                <option value="Silver">Silver</option>
                <option value="Gold">Gold</option>
                <option value="V.I.P">V.I.P</option>
              </select>
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="startDate">Start Date:</label>
            </div>
            <div>
              <input
                {...register("startDate", {
                  required: "Start Date is required",
                })}
                name="startDate"
                type="date"
                onChange={(e) => getDateValue(e.target.value)}
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-40 text-white text-2xl m-2">
              <label htmlFor="prepaid">Prepaid:</label>
            </div>
            <div>
              <input
                {...register("prepaid", {
                  required: "Prepaid is required",
                })}
                name="prepaid"
                type="number"
                min="0.00"
                step="0.01"
                placeholder="$0.00"
                className="w-72 text-2xl text-white bg-[#7a7a7a] focus:outline-none m-3 focus:border-gray-500 p-3 border-2 font-light border-gray-200 "
              />
            </div>
          </div>
        </div>
        <div className="flex justify-center gap-10">
            <SaveBtn
            canClick={isValid}
            isLoading={isLoading}
            actionText={"Save"}
            onClick={onSubmit}
            />
            <CancelBtn
            actionText={"Cancel"}
            onClick={onCancel}
            />

        </div>
      </form>
    </div>
  );
}

export default AddClient;
